import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL, goToCheckout } from "../utils/pixel";
type CheckoutButtonProps = {
  label: string;
  className?: string;
};
export function CheckoutButton({
  label,
  className = ""
}: CheckoutButtonProps) {
  return <a href={CHECKOUT_URL} onClick={e => {
    e.preventDefault();
    goToCheckout();
  }} className={`inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-4 text-base font-bold text-ink transition-transform duration-150 ease-out hover:-translate-y-0.5 active:scale-[0.98] sm:px-8 ${className}`} data-id="element-41" data-mp="1nktiyp9sgfr4">
      {label}
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-42" data-mp="18nugtgxphf41" />
    </a>;
}